export const group_outliners = [
    {
        'group': 'Albion St',
        'group_id': 1,
        'geojson': [
            {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                        [
                            [
                                151.21604975962623,
                                -33.88368760404412
                            ],
                            [
                                151.21595963460317,
                                -33.88397025382979
                            ],
                            [
                                151.21712124601692,
                                -33.884157300967296
                            ],
                            [
                                151.21767201005048,
                                -33.884070012354556
                            ],
                            [
                                151.21757687808093,
                                -33.88380398936347
                            ],
                            [
                                151.21704614183096,
                                -33.88385802535007
                            ],
                            [
                                151.21604975962623,
                                -33.88368760404412
                            ]
                        ]
                    ],
                    "type": "Polygon"
                }
            }
        ]
    },
    {
        'group': "Moore Park Rd",
        'group_id': 2,
        'geojson': [
            {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                        [
                            [
                                151.2189195627996,
                                -33.88638456308547
                            ],
                            [
                                151.21892802603588,
                                -33.88674989925119
                            ],
                            [
                                151.22059105171382,
                                -33.88682366886446
                            ],
                            [
                                151.2206037465681,
                                -33.886359973095374
                            ],
                            [
                                151.2189195627996,
                                -33.88638456308547
                            ]
                        ]
                    ],
                    "type": "Polygon"
                }
            }
        ]
    },
    {
        'group': 'Fitzroy St',
        'group_id': 3,
        'geojson': [
            {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                        [
                            [
                                151.21570763884722,
                                -33.8850285516556
                            ],
                            [
                                151.21566955428978,
                                -33.88532012277963
                            ],
                            [
                                151.21583458737348,
                                -33.88532363567836
                            ],
                            [
                                151.21793770127272,
                                -33.886286164563614
                            ],
                            [
                                151.218005407153,
                                -33.885994596741284
                            ],
                            [
                                151.21599538883714,
                                -33.88506016785031
                            ],
                            [
                                151.21570763884722,
                                -33.8850285516556
                            ]
                        ]
                    ],
                    "type": "Polygon"
                }
            }
        ]
    },
    {
        'group': "Cleveland St",
        'group_id': 4,
        'geojson': [
            {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                        [
                            [
                                151.1933238429096,
                                -33.88740824452184
                            ],
                            [
                                151.1929708225145,
                                -33.88772641741601
                            ],
                            [
                                151.19280944176444,
                                -33.88804458912349
                            ],
                            [
                                151.19311203067207,
                                -33.88820367453259
                            ],
                            [
                                151.19839725028788,
                                -33.88884838604634
                            ],
                            [
                                151.19881677547806,
                                -33.88902421699299
                            ],
                            [
                                151.2076826305198,
                                -33.890238268398456
                            ],
                            [
                                151.2115995609892,
                                -33.891671867624396
                            ],
                            [
                                151.2168948669012,
                                -33.89240027793055
                            ],
                            [
                                151.21694529838658,
                                -33.891713730454555
                            ],
                            [
                                151.21175085544303,
                                -33.891035550082506
                            ],
                            [
                                151.20796849407793,
                                -33.88955358161453
                            ],
                            [
                                151.20201190861582,
                                -33.88873513878492
                            ],
                            [
                                151.20132604042226,
                                -33.88851744424355
                            ],
                            [
                                151.19454804885407,
                                -33.88768015237024
                            ],
                            [
                                151.1933238429096,
                                -33.88740824452184
                            ]
                        ]
                    ],
                    "type": "Polygon"
                }
            },
        ]
    },
    {
        'group': "Cleveland St (Westbound)",
        'group_id': 5,
        'parent_id': 4,
        "geojson": [
            {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                        [
                            [
                                151.19309358413608,
                                -33.88780536708207
                            ],
                            [
                                151.1930056029085,
                                -33.88799683947289
                            ],
                            [
                                151.19512892528945,
                                -33.88822677904668
                            ],
                            [
                                151.19842295317147,
                                -33.88865776603335
                            ],
                            [
                                151.19884240853145,
                                -33.88879655824606
                            ],
                            [
                                151.20775944114337,
                                -33.89004810914819
                            ],
                            [
                                151.2116101648695,
                                -33.891493532505024
                            ],
                            [
                                151.21670829444082,
                                -33.89220821952992
                            ],
                            [
                                151.21673762683673,
                                -33.89208160738065
                            ],
                            [
                                151.21166605585864,
                                -33.891385237198286
                            ],
                            [
                                151.20778029060796,
                                -33.889913476077645
                            ],
                            [
                                151.19891017238962,
                                -33.8886805890067
                            ],
                            [
                                151.19845845351784,
                                -33.88853205705327
                            ],
                            [
                                151.19436072632828,
                                -33.88801340886103
                            ],
                            [
                                151.19309358413608,
                                -33.88780536708207
                            ]
                        ]
                    ],
                    "type": "Polygon"
                }
            }
        ]
    },
    {
        'group': "Cleveland St (Eastbound)",
        'group_id': 6,
        "parent_id": 4,
        "geojson": [
            {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                        [
                            [
                                151.21673079259506,
                                -33.89192656029788
                            ],
                            [
                                151.2116638109905,
                                -33.891252266010746
                            ],
                            [
                                151.20789735497505,
                                -33.889797870894235
                            ],
                            [
                                151.2017332181233,
                                -33.88896117976977
                            ],
                            [
                                151.20117818852606,
                                -33.88880115845102
                            ],
                            [
                                151.1984014509004,
                                -33.88840431044363
                            ],
                            [
                                151.19518998447967,
                                -33.88801226258234
                            ],
                            [
                                151.19439386339639,
                                -33.88787784556172
                            ],
                            [
                                151.19345509592102,
                                -33.88762661317988
                            ],
                            [
                                151.19333943668443,
                                -33.88773702750248
                            ],
                            [
                                151.1943283231613,
                                -33.887961056122826
                            ],
                            [
                                151.1951629973238,
                                -33.88808747201454
                            ],
                            [
                                151.19862141464318,
                                -33.88851855363129
                            ],
                            [
                                151.2011408649567,
                                -33.88888500003435
                            ],
                            [
                                151.2016516932535,
                                -33.889025816198526
                            ],
                            [
                                151.20774117389846,
                                -33.88987872178385
                            ],
                            [
                                151.2078499895519,
                                -33.8899037997536
                            ],
                            [
                                151.21167202983355,
                                -33.891369717171244
                            ],
                            [
                                151.21672115432563,
                                -33.89206737143938
                            ],
                            [
                                151.21673079259506,
                                -33.89192656029788
                            ]
                        ]
                    ],
                    "type": "Polygon"
                }
            }
        ]
    },
    {
        'group': "Gibbons St",
        'group_id': 7,
        'geojson': [
            {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                        [
                            [
                                151.19893798263644,
                                -33.89279688563676
                            ],
                            [
                                151.19792019004535,
                                -33.894924829345676
                            ],
                            [
                                151.19776115995285,
                                -33.895933339951966
                            ],
                            [
                                151.19834639069308,
                                -33.895896379040245
                            ],
                            [
                                151.19850542078416,
                                -33.89494066991852
                            ],
                            [
                                151.19952957457986,
                                -33.89286024949142
                            ],
                            [
                                151.19893798263644,
                                -33.89279688563676
                            ]
                        ]
                    ],
                    "type": "Polygon"
                }
            }
        ]
    },
    {
        'group': 'Chalmers St',
        'group_id': 8,
        'geojson': [
            {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                        [
                            [
                                151.20647164733634,
                                -33.88642193056752
                            ],
                            [
                                151.2057482489588,
                                -33.88955632126527
                            ],
                            [
                                151.2064187157481,
                                -33.889636876517635
                            ],
                            [
                                151.20707153867215,
                                -33.886495165309746
                            ],
                            [
                                151.20647164733634,
                                -33.88642193056752
                            ]
                        ]
                    ],
                    "type": "Polygon"
                }
            }
        ]
    },
    {
        'group': 'Chalmers St WS (Bedford - Rutland)',
        'group_id': 25,
        'parent_id': 8,
        'geojson': [
            {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                        [
                            [
                                151.20661414202795,
                                -33.886538482029
                            ],
                            [
                                151.20641745192137,
                                -33.88751496069835
                            ],
                            [
                                151.2065447219892,
                                -33.88752776690209
                            ],
                            [
                                151.20674141209594,
                                -33.88655448996562
                            ],
                            [
                                151.20661414202795,
                                -33.886538482029
                            ]
                        ]
                    ],
                    "type": "Polygon"
                }
            }
        ]
    },
    {
        'group': 'Chalmers St WS (Belvoir - Bedford)',
        'group_id': 24,
        'parent_id': 8,
        'geojson': [
            {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                        [
                            [
                                151.2064205783816,
                                -33.887520067833094
                            ],
                            [
                                151.20619859959726,
                                -33.888581572224744
                            ],
                            [
                                151.20631427868267,
                                -33.88859454896887
                            ],
                            [
                                151.20653313100337,
                                -33.887535640120035
                            ],
                            [
                                151.2064205783816,
                                -33.887520067833094
                            ]
                        ]
                    ],
                    "type": "Polygon"
                }
            }
        ]
    },
    {
        'group': "Chalmers St WS (Cleveland - Belvoir)",
        'group_id': 22,
        'parent_id': 8,
        'geojson': [
            {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                        [
                            [
                                151.20619774615562,
                                -33.888590555434355
                            ],
                            [
                                151.2059554054535,
                                -33.889617911975236
                            ],
                            [
                                151.20608860034412,
                                -33.88963326848084
                            ],
                            [
                                151.20631429168424,
                                -33.888605912124916
                            ],
                            [
                                151.20619774615562,
                                -33.888590555434355
                            ]
                        ]
                    ],
                    "type": "Polygon"
                }
            }
        ]
    },
    {
        'group': "Chalmers St (East Side)",
        'group_id': 23,
        'parent_id': 8,
        'geojson': [
            {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                        [
                            [
                                151.20674608493994,
                                -33.88655662296161
                            ],
                            [
                                151.20610234909918,
                                -33.8896324440532
                            ],
                            [
                                151.20626087275662,
                                -33.88965581095644
                            ],
                            [
                                151.206886098599,
                                -33.88657738960175
                            ],
                            [
                                151.20674608493994,
                                -33.88655662296161
                            ]
                        ]
                    ],
                    "type": "Polygon"
                }
            }
        ]
    }
];